import React, { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Loading from "../Loading/Loading";
import config from "../../config";
import { RandomId } from "../../Utils/RandomId";
import { UploadFiles, base64toFile, renameFile } from "../../Utils/UploadFile";
import { encryptFileAES } from "../../Utils/OstreonEncryption";
import { UserData } from "../../Context/DataContext";
import { buildPrivateKey } from "../../Utils/beneficiaryUtils";
import { generateCode } from "../../Utils/personalCode";
import { LanguageContext } from "../../Context/changeLanguageProvider";
import { sendUIErrorToBackend } from "../../Utils/sendErrorToBackend";
import { createAccess } from "../../Utils/beneficiary";
const base_url = config?.base_url;

function PreparePartner({}) {
  const websiteCurrentLang = useContext(LanguageContext).language;

  const [dublicatedcontent, setDublicatedContent] = useState(
    websiteCurrentLang.content.DublicatedText
  );
  useEffect(() => {
    setDublicatedContent(websiteCurrentLang.content.DublicatedText);
  }, [websiteCurrentLang]);

  const location = useLocation();
  const navigate = useNavigate();
  if (!location?.state?.partner) navigate("/logout", { replace: true });
  const userData = UserData();
  useEffect(() => {
    if (!location?.state?.partner) return;
    fetch(base_url + "user/prepare/data/partner", {
      method: "POST",
      mode: "cors",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-type": "application/x-www-form-urlencoded",
        credentials: "include",
      },
      credentials: "include",
    })
      .then((res) => {
        if (res.status !== 200) navigate("/logout", { replace: true });
        else return res?.json();
      })
      .then(async (data) => {
        if (data?.continue) {
          setTimeout(() => {
            navigate("/user/prepare", {
              replace: true,
              state: { prepare: true },
            });
          }, 500);
        } else {
          //We need to
          // 1. Upload the profile avatars to trustees and beneficiaries
          // 2. Upoad the Asset Files and Beneficiary documents
          // 3. Create the beneficiaries accounts
          // const {assets, beneficiaries, trustees, legal} = data
          const files_to_upload = [];
          const pics_to_upload = [];
          const assets = data?.assets?.map((asset) => {
            return {
              ...asset,
              asset_files: asset?.asset_files?.map((file) => {
                const file_id = RandomId(32);
                const newFile = base64toFile(file?.base64_data, file_id);
                files_to_upload.push(newFile);
                return {
                  id: file_id,
                  name: file.fileName,
                  size: newFile.size,
                  lastModified: newFile.lastModified,
                };
              }),
            };
          });
          const beneficiaries = data?.beneficiaries?.map((beneficiary) => {
            return {
              ...beneficiary,
              personal_code: generateCode(),
              personal_documents: beneficiary?.personal_documents?.map(
                (file) => {
                  const file_id = RandomId(32);
                  const newFile = base64toFile(file?.base64_data, file_id);
                  files_to_upload.push(newFile);
                  return {
                    id: file_id,
                    name: file.fileName,
                    size: newFile.size,
                    lastModified: newFile.lastModified,
                  };
                }
              ),
            };
          });
          const trustees = data?.trustees;
          data?.beneficiaries
            ?.filter((e) => e?.profile_avatar)
            .map((e) => {
              pics_to_upload.push({
                id: e?.user_id,
                file: base64toFile(e?.profile_avatar, "avatar"),
              });
            });
          data?.trustees
            ?.filter((e) => e?.profile_avatar)
            .map((e) => {
              pics_to_upload.push({
                id: e?.user_id,
                file: base64toFile(e?.profile_avatar, "avatar"),
              });
            });
          if (data?.you)
            pics_to_upload.push({
              id: data?.you?.user_id,
              file: base64toFile(data?.you?.profile_avatar, "avatar"),
            });
          console.log(pics_to_upload);
          pics_to_upload?.map(async (avatar) => {
            const formData = new FormData();
            const private_key = userData?.private_key;
            const encrypted_image = await encryptFileAES(
              private_key,
              avatar?.file
            );
            formData.append("file", encrypted_image);
            formData.append("profile_id", avatar?.id);
            return fetch(base_url + "user/profile/pic/upload", {
              method: "POST",
              mode: "cors",
              body: formData,
              credentials: "include",
            });
          });

          await UploadFiles(
            files_to_upload,
            userData?.private_key,
            undefined,
            undefined
          );
          // Create the beneficiaries
          beneficiaries?.map(async (beneficiary) => {
            // return
            const beneficiary_accesses= await Promise.all([buildPrivateKey(
              userData?.private_key,
              beneficiary?.email,
              beneficiary?.birth_date,
              beneficiary?.personal_code
            )]);
            const body = {
              email:beneficiary.email,
              beneficiary_user_id:beneficiary.user_id,
              accesses:beneficiary_accesses
            }
            createAccess(body, "add")
            .then(()=>{
              return
            })
            .catch(err=>console.log(err))
          });
          console.log(assets);
          userData.setUserData({
            ...userData.UserData,
            beneficiaries,
            assets,
            trustees,
          });
          setTimeout(() => {
            navigate("/user/prepare", {
              replace: true,
              state: { prepare: true },
            });
          }, 3000);
        }
      })
      .catch((e) => {
        sendUIErrorToBackend(e)
        setTimeout(() => {
          navigate("/user/prepare", {
            replace: true,
            state: { prepare: true },
          });
        }, 2000);
      });
  }, []);

  return (
    <div
      style={{
        top: "0",
        left: "0",
        right: "0",
        bottom: "0",
        position: "fixed",
        zIndex: "10000",
        height: "100vh",
        width: "100vw",
        backgroundColor: "white",
        opacity: 1,
      }}
    >
      <Loading text={dublicatedcontent.dublicatedText257} />
    </div>
  );
}
export default PreparePartner;
